import * as React from "react";
const SvgArrowLeft = (props) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.59961 9L10.5996 3L12 4.40039L7.40039 9L12 13.5996L10.5996 15L4.59961 9Z" }));
export default SvgArrowLeft;
